// Keep the light surfaces and purple hero consistent for all visitors.
document.documentElement.setAttribute('data-theme', 'light');
